import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} payload - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const selectedTemplateHandler = (
  payload = null,
  type = types.SELECTED_TEMPLATE
) => {
  return {
    type,
    payload
  };
};
